import { SITE_URL } from '@/config/siteConfig';
import { getPrerenderPath, stripHtmlSuffix } from '@/lib/i18n/routes';

/**
 * Single source of truth for a page's canonical absolute URL.
 *
 * SEOHead uses this for <link rel="canonical"> / og:url, and JsonLdSchema uses
 * it for structured-data `url` and `@id` values, so JSON-LD entity URLs always
 * match the language-specific canonical of the page they are embedded in.
 */
export function buildCanonicalUrl(pathname: string): string {
  return `${SITE_URL}${getPrerenderPath(stripHtmlSuffix(pathname))}`;
}
